export default __webpack_public_path__ + "static/media/maping.674b249c.svg";